import { $, findTarget } from '../utils/Utils';

const select = (() => {
  const triggerCN = '.js-selectTrigger';
  const triggers = [...$(triggerCN)];
  const labelCN = 'js-selectLabel';
  const parent = 'js-selectParent';

  const getValue = trigger => trigger.options[trigger.selectedIndex].value;

  const getLabel = trigger => trigger.options[trigger.selectedIndex].dataset.label;

  const updateLabel = (trigger) => {
    const thisLabel = findTarget({ element: trigger, parent, target: labelCN });

    // Gives the ability to have a data-label to show non-formatted value in the select
    thisLabel.textContent = (getLabel(trigger) !== undefined)
      ? getLabel(trigger)
      : getValue(trigger);
  };

  const build = () => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('change', () => {
        updateLabel(trigger);
      });
    });
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  // outside functions
  const update = (targetParent) => {
    updateLabel(targetParent.querySelector(triggerCN));
  };

  const reboot = (targetParent) => {
    const trigger = targetParent.querySelector(triggerCN);
    const thisLabel = findTarget({ element: trigger, parent, target: labelCN });
    thisLabel.textContent = trigger.options[trigger.selectedIndex].textContent;
  };

  return {
    init,
    update,
    reboot,
    getValue,
    getLabel,
  };
})();

select.init();

export default select;



// WEBPACK FOOTER //
// ./components/select.js